// extracted by mini-css-extract-plugin
module.exports = {"iconList":"iconlist-module--icon-list--3HYyy","iconWrapper":"iconlist-module--icon-wrapper--2UQeu","textWrapper":"iconlist-module--text-wrapper--1YpbZ"};